import { SecondaryNavItem } from '@zola-helpers/client/dist/es/constants/navConstants';
import NavMapper from 'components/navV2/NavMapper';
import React from 'react';
import { TertiaryNavWrapper } from './TertiaryNav.styles';

type TertiaryNavProps = {
  tertiaryNavData: SecondaryNavItem[];
  activeTertiaryLink?: string;
};

const TertiaryNav = (props: TertiaryNavProps): JSX.Element => {
  const { tertiaryNavData, activeTertiaryLink } = props;

  return (
    <TertiaryNavWrapper>
      <NavMapper
        className="navTertiary__container--postAuthNavV3"
        navData={tertiaryNavData}
        type="Tertiary"
        activeLinkId={activeTertiaryLink}
      />
    </TertiaryNavWrapper>
  );
};

export default TertiaryNav;
